<template>
  <div class="dashboard-editor-container">
    <el-card class="salesCard">
      <div class="salesCard">
        <el-form :inline="true">
          <el-form-item label="平台" prop="platForm">
            <el-select v-model="queryParams.platForm" style="width: 130px" placeholder="请选择">
              <el-option
                v-for="item in platForm"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="国家" prop="startDate">
            <el-select v-model="queryParams.country" size="small" style="width: 150px" placeholder="请选择">
              <el-option
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="queryParams.startDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              size="small"
              style="width: 150px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>注册</span>
          </div>
          <el-row :gutter="24" style="margin:10px 0px">
            <el-row :gutter="24">
              <el-col :span="8">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="reg.userCount"
                    title="新增"
                  />
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="reg.android"
                    title="安卓"
                  />
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="reg.ios"
                    title="苹果"
                  />
                </div>
              </el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>来源</span>
          </div>
          <el-row :gutter="24" style="margin:10px 0px">
            <el-row :gutter="24">
              <el-col :span="6">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="sourceData.invitation"
                    title="邀请"
                  />
                </div>
              </el-col>
              <!--              <el-col :span="6">-->
              <!--                <div>-->
              <!--                  <el-statistic-->
              <!--                    group-separator=","-->
              <!--                    :value="sourceData.share"-->
              <!--                    title="分享"-->
              <!--                  />-->
              <!--                </div>-->
              <!--              </el-col>-->
              <!--              <el-col :span="6">-->
              <!--                <div>-->
              <!--                  <el-statistic-->
              <!--                    group-separator=","-->
              <!--                    :value="sourceData.other"-->
              <!--                    title="其他"-->
              <!--                  />-->
              <!--                </div>-->
              <!--              </el-col>-->
              <el-col :span="6">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="sourceData.natural"
                    title="自然"
                  />
                </div>
              </el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 10px">
      <el-col :span="8">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>登录</span>
          </div>
          <el-row :gutter="24" style="margin:10px 0px">
            <el-row :gutter="24">
              <el-col :span="8">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="login.userCount"
                    title="登录"
                  />
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="login.android"
                    title="安卓"
                  />
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="login.ios"
                    title="苹果"
                  />
                </div>
              </el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>订单</span>
          </div>
          <el-row :gutter="24" style="margin:10px 0px">
            <el-row :gutter="24">
              <el-col :span="6">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="order.price"
                    prefix="$"
                    title="付费金额"
                  />
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="order.userCount"
                    title="付费人数"
                  />
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <el-statistic
                    group-separator=","
                    :value="order.count"
                    title="订单数"
                  />
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <el-statistic
                    :value="order.payRate"
                    suffix="%"
                    title="付费率"
                  />
                </div>
              </el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="24">
        <IndexUserRegAnalyze />
      </el-col>
    </el-row>

    <!--    <el-row :gutter="10">-->
    <!--      <el-col :span="24">-->
    <!--        <IndexUserPayAnalyze />-->
    <!--      </el-col>-->
    <!--    </el-row>-->

    <el-row :gutter="10" class="mtop">
      <el-col :span="24">
        <NewUserLoginStat />
      </el-col>
    </el-row>

    <el-row :gutter="10" class="mtop">
      <el-col :span="24">
        <NewUserLevelStat />
      </el-col>
    </el-row>

    <el-row :gutter="10" class="mtop">
      <el-col :span="24">
        <NewUserSpinStat />
      </el-col>
    </el-row>

    <el-row :gutter="10" class="mtop">
      <el-col :span="24">
        <NewUserLoginStat :typ="2" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUserAnalyze } from '@/api/statistics/user_remain'
import IndexUserRegAnalyze from '@/components/Index/IndexUserRegAnalyze.vue'
import NewUserLoginStat from '@/components/Index/NewUserLoginStat.vue'
import NewUserLevelStat from '@/components/Index/NewUserLevelStat.vue'
import NewUserSpinStat from '@/components/Index/NewUserSpinStat.vue'
import { getCacheQuery, setCacheQuery } from '@/utils'

export default {
  name: 'UserAnalyze',
  components: {
    IndexUserRegAnalyze,
    NewUserLoginStat,
    NewUserLevelStat,
    NewUserSpinStat
  },
  filters: {
    addToField1(value) {
      return '$' + value
    },
    addToField2(value) {
      return value + '%'
    },
    scientificFormat(value) {
      if (value === 0) {
        return 0
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
  },
  data() {
    return {
      reg: { android: 0, ios: 0, userCount: 0 },
      login: { android: 0, ios: 0, userCount: 0 },
      order: { count: 0, price: 0, userCount: 0, successCount: 0, unpaidCount: 0, payRate: 0 },
      sourceData: { invitation: 0, share: 0, other: 0, natural: 0 },
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        platForm: ''
      },
      platForm: [{ label: '全部', value: '' }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      country: []
    }
  },
  created() {
    this.getTable(undefined)
  },
  methods: {
    getTable(event) {
      this.order = { count: 0, price: 0, userCount: 0, successCount: 0, unpaidCount: 0, payRate: 0 }
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getUserAnalyze(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.sourceData.invitation = res.data.data2.invite_reg
          this.sourceData.natural = res.data.data2.user_naturally
          const data = res.data.data
          const country = res.data.country
          this.country = [{ label: '全部', value: '' }]
          for (const i in country) {
            this.country.push({ label: country[i], value: i })
          }

          for (const i in data) {
            const val = data[i]
            if (val.channel === 1) {
              this.reg.android = val.reg_count
              this.login.android = val.log_count
            } else {
              this.reg.ios = val.reg_count
              this.login.ios = val.log_count
            }

            this.order.successCount += val.pay_count
            this.order.unpaidCount += val.unpaid_count
            this.order.price += val.price.toFixed(2)
            this.order.userCount += val.pay_user
          }

          this.reg.userCount = this.reg.android + this.reg.ios
          this.login.userCount = this.login.android + this.login.ios
          this.order.count = this.order.successCount + this.order.unpaidCount
          if (this.login.userCount > 0) {
            this.order.payRate = (this.order.successCount / this.login.userCount * 100).toFixed(2)
            this.order.payRate = parseFloat(this.order.payRate)
          }

          // console.log(this.order)
          this.queryParams = res.data.req
          if (this.queryParams.platForm === 0) {
            this.queryParams.platForm = ''
          }
        }
      })
    },
    handleQuery() {
      this.getTable({})
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 12px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

::v-deep .el-tabs__item{
   padding-left: 16px!important;
   height: 50px;
   line-height: 50px;
}

@media (max-width:1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
.user_add{
  font-size: 20px;
  font-weight: bold;
}
.salesCard{
  margin-bottom: 10px;
}
.mtop{
  margin-top: 20px;
}
</style>
